import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const SecurityItemDetails = ( { data } ) => {

    return (
        <div style={{display:"flex", justifyContent:"space-between", width: "100%", height: "100%"}}>
            <div style={{ whiteSpace: 'pre-wrap', height: "100%"}}>
              
                
            </div>
            
        </div>
    )
}
export default SecurityItemDetails;